import React, {useState, useEffect} from "react";
import ActivitiesPost from '../api/ActivitiesPost'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import swal from 'sweetalert';
import 
    GetAllActivities
from '../api/Activities';
import GetAllRoutines from "../api/Routines";
import './activities.css';

const Activities  = (props) => {

    const [activityName, setActivityName] = useState("");
    const [activityDescription, setActivityDescription] = useState("");

    const {activity, setActivity, routine, setRoutine, user, token, setUser } = props 
    
    useEffect( () => {
        GetAllActivities().then(setActivity);
        GetAllRoutines().then(setRoutine);
        
    },[])

    useEffect( () => {
        GetAllActivities().then(setActivity);
        
    },[setActivity])
    
       
        
         return ( <>
          <Form className='form'>
                    <Form.Group width='90%' controlId="formBasicEmail">
                        <Form.Label><b>Activity Name:</b></Form.Label>
                        <Form.Control width='50%' type="text" placeholder="Activity name" value={activityName} onChange={(event )=> {
                            event.preventDefault();
                        let activityName = event.target.value;
                        
                         return setActivityName(activityName);
                        }} />
                        <Form.Text className="text">
                        Name your Activity so we can get to it!
                        </Form.Text>
                    </Form.Group>

                    <Form.Group controlId="formBasicPassword">
                        <Form.Label><b>Activity Description:</b></Form.Label>
                        <Form.Control type="text" placeholder="Activity Description" value={activityDescription} onChange={(event )=> {
                            event.preventDefault();
                            let activityDescription = event.target.value;
                            
                            return setActivityDescription(activityDescription)
                        }}/>
                    </Form.Group>
                    <Form.Group controlId="formBasicCheckbox">
                        <Form.Check type="checkbox" label="Make public?" />
                    </Form.Group>
                    <Button variant="primary" type="submit" value={activityName, user, activityDescription, token} onClick={ async (event) => {
                        event.preventDefault();
                        
                        try {
                        
                        
                        const activity = await ActivitiesPost({  activityName, activityDescription, token })
                        if(activity.error){
                            swal(`${activity.error}`)
                        }
                        
                        } catch (error) {
                            console.error(error)
                        } finally {
                            await GetAllActivities().then(setActivity);
                        }
                    }}>
                        Post
                    </Button>
                    </Form>
          { activity && activity.map(({id, name, description}) =>
          
            
                <div key={id} style={{border :  '8px double black',
                width: '380px',
                letterSpacing: '3px',
                backgroundColor: 'navajowhite'}}>
                <div class="card-body">
                <h5 class="card-title">{name}</h5>
          <h6 class="card-subtitle mb-2 text">{description}</h6>
         
                </div>
            </div>)}
            { routine && routine.map(({ index, id, creatorId, isPublic, name, creatorName, goal, activities}) => {
                {activities && activities.map(({name, count, duration}) => {
                <div key={id}>
                <div class="card-body">
                <h5 class="card-title">{name}</h5>
          <h6 class="card-subtitle mb-2 text">{count}</h6>
          <h6 class="card-subtitle mb-2 text">{duration}</h6>
          
          
         <p class="card-text">Activity by: { user.id === creatorId ? user.username : ""}
         </p>
                </div>
            </div>
                })}
                
            })}
        
            
            
            
            </>)
    
    

};
export default Activities;